import { getHttpClient } from 'src/http-client';

interface AzureStateDefinitionReponse {
  id: string;
  color: string;
  stateCategory: string;
  name: string;
  order: number;
  url: string;
  customizationType: string;
}

export async function getAzureStateDefinitionsService(args: {
	organizationName: string;
  processId: string;
  workItemType: string;
}):Promise<Array<AzureStateDefinitionReponse> | null> {
	try {
		const api = getHttpClient();
		const response = await api.get(`https://dev.azure.com/${args.organizationName}/_apis/work/processes/${args.processId}/workItemTypes/${args.workItemType}/states?api-version=7.1-preview.1`);
		if (response.status === 200 && response.data) {
			return response.data.value;
		}

		return null;
  
	} catch (err) {
		throw new Error('Get azure state definitions error');
	}
}